import { render } from "./RollTransition.vue?vue&type=template&id=06736240&scoped=true"
const script = {}

import "./RollTransition.vue?vue&type=style&index=0&id=06736240&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06736240"]])

export default __exports__